import { useContext, useEffect, useState } from 'react';
import {
  Badge,
  Box,
  ButtonBase,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Add,
  CalendarMonth,
  DeleteOutline,
  Description,
  DoneAll,
  Edit,
  Email,
  FilterAlt,
  FilterList,
  History,
  LocationOn,
  Notes,
  Person,
  Phone,
  Plagiarism,
  PriorityHigh,
  Store,
  WhatsApp,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { encryptURL, summarizer } from 'utils/functions';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { CrmContext } from 'contexts/CrmContext';
import { useDrawer } from 'components/Modals';
import { useModal } from 'components/Modals';
import VirtualDrop from 'components/VirtualDrop';
import InputMask from 'components/InputMask';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Loader from 'components/Loader';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';
import styles from './styles';
import moment from 'moment';

const defaultValues = {
  nome: '',
  contato: '',
  responsavel: [],
  cidade: [],
  execucao_i: null,
  execucao_f: null,
  valor_i: '',
  valor_f: '',
  descricao: '',
};

const FunilCard = ({ key, item, index, historico = [] }) => {
  const inDate = item?.createdAt && moment(item?.createdAt);
  let outDate = null;

  if (Boolean(item?.funil_id)) {
    for (let i = index - 1; i >= 0; i--) {
      if (Boolean(historico[i]?.funil_id) && Boolean(historico[i]?.createdAt)) {
        outDate = moment(historico[i]?.createdAt);
        break;
      }
    }
  }

  const showUser = Boolean(item?.users);
  const showIn = inDate?.isValid();
  const showOut = Boolean(outDate) && outDate?.isValid();

  return (
    <Box key={key} mb={1} px={1} py={1}>
      <Card>
        <Box sx={styles?.modalCard}>
          <FilterAlt fontSize="small" />
          <Box flex={1} sx={styles?.modalCardContent}>
            <Typography>{item?.historico}</Typography>
            {showIn && (
              <Typography variant="caption" color="text.secondary">
                Entrou em {inDate.format('DD/MM/YYYY')}
              </Typography>
            )}
            {showOut && (
              <Typography variant="caption" color="text.secondary">
                Saiu em {outDate.format('DD/MM/YYYY')}
              </Typography>
            )}
            {showUser && (
              <Typography variant="caption" color="text.secondary">
                Atualizado por {item?.users}
              </Typography>
            )}
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

const CalendarioCard = ({ key, item, onDone, onDelete }) => {
  const { postLoading, deleteLoading } = useContext(CrmContext);
  const conclusaoDate = item?.conclusao && moment(item.conclusao);
  const execucaoDate = item?.execucao && moment(item.execucao);
  const showDelete = !item?.gatilho_id && !item?.conclusao;
  const showExecute = item?.execucao && !item?.conclusao;
  const showConclusao = conclusaoDate?.isValid();
  const showExecucao = execucaoDate?.isValid();
  const showUser = Boolean(item?.users);

  return (
    <Box key={key} mb={1} px={1} py={1}>
      <Card>
        <Box sx={styles?.modalCard}>
          <CalendarMonth fontSize="small" />
          <Box flex={1} sx={styles?.modalCardContent}>
            <Typography>{item?.historico}</Typography>
            {showExecucao && (
              <Typography variant="caption" color="text.secondary">
                Executar em {execucaoDate.format('DD/MM/YYYY')}
              </Typography>
            )}
            {showConclusao && (
              <Typography variant="caption" color="text.secondary">
                Executado em {conclusaoDate.format('DD/MM/YYYY')}
              </Typography>
            )}
            {showUser && (
              <Typography variant="caption" color="text.secondary">
                Executado por {item?.users}
              </Typography>
            )}
          </Box>
          {showExecute && (
            <ButtonBase onClick={() => onDone(item?.id)} disabled={postLoading}>
              <DoneAll fontSize="small" />
            </ButtonBase>
          )}
          {showDelete && (
            <ButtonBase
              onClick={() => onDelete(item?.id)}
              disabled={deleteLoading}
            >
              <DeleteOutline fontSize="small" />
            </ButtonBase>
          )}
        </Box>
      </Card>
    </Box>
  );
};

const AnotacaoCard = ({ key, item, onDelete }) => {
  const { deleteLoading } = useContext(CrmContext);
  const inDate = item?.createdAt && moment(item?.createdAt);
  const showDelete = !item?.gatilho_id && !item?.conclusao;
  const showUser = Boolean(item?.users);
  const showIn = inDate?.isValid();

  return (
    <Box key={key} mb={1} px={1} py={1}>
      <Card>
        <Box sx={styles?.modalCard}>
          <History fontSize="small" />
          <Box flex={1} sx={styles?.modalCardContent}>
            <Typography>{item?.historico}</Typography>
            {showIn && (
              <Typography variant="caption" color="text.secondary">
                Anotado em {inDate.format('DD/MM/YYYY')}
              </Typography>
            )}
            {showUser && (
              <Typography variant="caption" color="text.secondary">
                Anotado por {item?.users}
              </Typography>
            )}
          </Box>
          {showDelete && (
            <ButtonBase
              onClick={() => onDelete(item?.id)}
              disabled={deleteLoading}
            >
              <DeleteOutline fontSize="small" />
            </ButtonBase>
          )}
        </Box>
      </Card>
    </Box>
  );
};

const DescricaoModal = ({ lead }) => {
  const { closeModal } = useModal();
  return (
    <>
      <DialogTitle>Descrição do Lead</DialogTitle>
      <DialogContent>
        <DialogContentText>{lead?.descricao}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={closeModal}>
          Voltar
        </Button>
      </DialogActions>
    </>
  );
};

const DescarteModal = ({ lead, onSubmit }) => {
  const defaultValues = { id: lead?.id, motivo_descarte_id: null };
  const { closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { postLoading } = useContext(CrmContext);
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <>
      <DialogTitle>Descarte do Lead</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Dropdown
              name="motivo_descarte_id"
              control={control}
              label="Motivo de Descarte"
              options={drops?.CrmMotivoDescarte}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(onSubmit)}
          loading={postLoading}
        >
          Salvar
        </Button>
        <Button variant="contained" color="secondary" onClick={closeModal}>
          Voltar
        </Button>
      </DialogActions>
    </>
  );
};

const FiltroModal = ({ control, onSubmit, handleSubmit }) => {
  const { drops } = useContext(DropsContext);

  return (
    <Box m="1em">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Input name="nome" control={control} label="Nome (Empresa)" />
        </Grid>
        <Grid item xs={12}>
          <Input name="contato" control={control} label="Contato (Pessoa)" />
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            name="responsavel"
            control={control}
            label="Responsável"
            options={drops?.Users}
            multiple
          />
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            name="cidade"
            control={control}
            label="Cidade"
            options={drops?.Cidade}
            multiple
          />
        </Grid>
        <Grid item xs={6}>
          <InputMask
            name="execucao_i"
            control={control}
            label="Data da Execução (Inicial)"
            type="date"
          />
        </Grid>
        <Grid item xs={6}>
          <InputMask
            name="execucao_f"
            control={control}
            label="Data da Execução (Final)"
            type="date"
          />
        </Grid>
        <Grid item xs={6}>
          <InputMask name="valor_i" control={control} label="Valor (Inicial)" />
        </Grid>
        <Grid item xs={6}>
          <InputMask name="valor_f" control={control} label="Valor (Final)" />
        </Grid>
        <Grid item xs={12}>
          <Input name="descricao" control={control} label="Descrição" />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
          >
            FILTRAR
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

const HistoricoModal = ({ lead }) => {
  const { closeModal } = useModal();
  const [historico, setHistorico] = useState([]);
  const {
    getHistorico,
    getLoading,
    postHistorico,
    postLoading,
    deleteHistorico,
  } = useContext(CrmContext);
  const defaultValues = {
    lead_id: lead?.id,
    historico: '',
    execucao: null,
    conclusao: null,
  };
  const { control, reset, handleSubmit } = useForm({ defaultValues });

  const loadData = () => {
    reset();
    getHistorico({ params: { id: lead?.id }, cb: setHistorico });
  };

  const onSubmit = (data) => postHistorico({ data, cb: loadData });

  const onDelete = (id) => deleteHistorico({ id, cb: loadData });

  const onDone = (id) =>
    onSubmit({ id, conclusao: moment().format('YYYY-MM-DD') });

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <DialogTitle>Registro de Atividades</DialogTitle>
      <DialogContent sx={styles?.modal}>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          <Grid item xs={12} sm={8}>
            <Input
              name="historico"
              control={control}
              placeholder="Descreva aqui o registro da atividade"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask
              name="execucao"
              control={control}
              label="Data da Execução"
              type="date"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              loading={postLoading}
              onClick={handleSubmit(onSubmit)}
            >
              Adicionar
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign="center">
            {getLoading ? (
              <Loader />
            ) : historico?.length > 0 ? (
              <Box sx={styles?.modalScroll}>
                {historico?.map((item, index) => {
                  const key = item?.id || index.toString();
                  const props = { item, index, key, onDone, onDelete };

                  if (Boolean(item?.funil_id)) {
                    return <FunilCard {...props} historico={historico} />;
                  }
                  if (Boolean(item?.execucao)) {
                    return <CalendarioCard {...props} />;
                  }
                  return <AnotacaoCard {...props} />;
                })}
              </Box>
            ) : (
              <Typography variant="caption" color="text.secondary">
                Nenhum registro encontrado
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={closeModal}>
          Voltar
        </Button>
      </DialogActions>
    </>
  );
};

const Crm = () => {
  const titulo = 'CRM';
  const navigate = useNavigate();
  const [badge, setBadge] = useState(0);
  const [funil, setFunil] = useState([]);
  const [leads, setLeads] = useState([]);
  const { getFunil, getLeads, getLoading, postLead } = useContext(CrmContext);
  const { openModal, closeModal } = useModal();
  const { openDrawer, closeDrawer } = useDrawer();
  const formProps = useForm({ defaultValues });

  const loadLeads = (params) => {
    const cb = (res) => {
      if (res?.filtros) {
        setBadge(Object.keys(res?.filtros)?.length);
      }
      setLeads(res?.data || []);
    };
    getLeads({ params, cb });
    closeDrawer();
    closeModal();
  };

  useEffect(() => {
    getFunil({ cb: setFunil });
    loadLeads();
  }, []);

  const handleEdit = (item) => navigate(`/app/Crm/Gerar/${encryptURL(item)}`);

  const handleDescricao = (item) => openModal(<DescricaoModal lead={item} />);

  const handleDocumento = (item) =>
    navigate(`/app/Orcamentos/Gerar/${encryptURL(item)}`);

  const handleSearchDocumento = (item) =>
    navigate(`/app/Documento/${item?.documento_id}`);

  const handleDescarte = (item) =>
    openModal(
      <DescarteModal
        lead={item}
        onSubmit={(data) => postLead({ data, cb: loadLeads })}
      />
    );

  const handleHistorico = (item) =>
    openModal(<HistoricoModal lead={item} />, 90);

  const Stepper = ({ item }) => {
    const _leads = leads?.filter((f) => f?.funil_id === item?.id);
    const valor_total = summarizer(_leads, 'valor') || 0;
    const Line = ({ value, label, Icon }) => (
      <Box display="flex" alignItems="center">
        {Icon ? (
          <Box flex={0.3}>
            <Icon fontSize="small" flex={1} />
          </Box>
        ) : (
          <Typography
            variant="caption"
            fontWeight="bold"
            flex={1}
            lineHeight={1.5}
          >
            {label}:
          </Typography>
        )}
        <Box display="flex" alignItems="center" flex={2}>
          <Typography variant="caption" flex={1} lineHeight={1.5}>
            {value || '-'}
          </Typography>
        </Box>
      </Box>
    );

    return (
      <Paper sx={styles?.stepContainer} elevation={3}>
        <Box sx={styles?.header}>
          <Box flex={1}>
            <Typography flex={1} variant="h6" color="primary.white">
              {item?.descricao}
            </Typography>
            <Typography flex={1} variant="caption" color="primary.white">
              {item?.fase}
            </Typography>
            <Typography flex={1} variant="subtitle2" color="primary.white">
              {valor_total?.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
          </Box>
        </Box>
        {_leads?.map((lead) => (
          <Paper sx={styles?.leadPaper} elevation={1}>
            <Box flex={1} gap={2} display="flex" justifyContent="flex-end">
              {(lead?.dias || 0) > (item?.tempomax || 0) && (
                <Tooltip title="Lead em atraso">
                  <PriorityHigh fontSize="small" color="error" />
                </Tooltip>
              )}
              <Tooltip title="Editar">
                <ButtonBase onClick={() => handleEdit(lead)}>
                  <Edit fontSize="small" />
                </ButtonBase>
              </Tooltip>
              <Tooltip title="Descartar Lead">
                <ButtonBase onClick={() => handleDescarte(lead)}>
                  <DeleteOutline fontSize="small" />
                </ButtonBase>
              </Tooltip>
              <Badge variant="dot" color="secondary" invisible>
                <Tooltip title="Registros de Atividades">
                  <ButtonBase onClick={() => handleHistorico(lead)}>
                    <History fontSize="small" />
                  </ButtonBase>
                </Tooltip>
              </Badge>
              {Boolean(item?.permite_proposta === 'SIM') &&
                !Boolean(lead?.documento_id) && (
                  <Tooltip title="Gerar Orçamento">
                    <ButtonBase onClick={() => handleDocumento(lead)}>
                      <Description fontSize="small" />
                    </ButtonBase>
                  </Tooltip>
                )}
              {Boolean(lead?.documento_id) && (
                <Tooltip title="Ver Orçamento">
                  <ButtonBase onClick={() => handleSearchDocumento(lead)}>
                    <Plagiarism fontSize="small" />
                  </ButtonBase>
                </Tooltip>
              )}
              {Boolean(lead?.descricao) && (
                <Tooltip title="Ver Descrição">
                  <ButtonBase onClick={() => handleDescricao(lead)}>
                    <Notes fontSize="small" />
                  </ButtonBase>
                </Tooltip>
              )}
            </Box>
            <Line label="Nome" value={lead?.contato} Icon={Person} />
            <Line label="Contato" value={lead?.nome} Icon={Store} />
            <Line label="E-Mail" value={lead?.email} Icon={Email} />
            <Line label="Telefone" value={lead?.fone} Icon={Phone} />
            <Line label="WhatsApp" value={lead?.whatsapp} Icon={WhatsApp} />
            <Line
              label="Cidade"
              value={Boolean(lead?.cidade) && lead?.cidade + ' / ' + lead?.uf}
              Icon={LocationOn}
            />
            <Line
              label="Data"
              value={
                Boolean(lead?.dias) &&
                `Criado há ${lead?.dias} ${lead?.dias > 1 ? 'dias' : 'dia'}`
              }
              Icon={CalendarMonth}
            />
            <Typography variant="subtitle2" flex={1} textAlign="end">
              {lead?.valor?.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Typography>
            <Typography variant="caption" flex={1} color="text.secondary">
              * {lead?.responsavel} é responsavel por esse lead
            </Typography>
          </Paper>
        ))}
        {getLoading && <Loader />}
      </Paper>
    );
  };

  if (getLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <Header titulo={titulo} />
      <Box sx={styles?.container}>
        {funil?.map((item, index) => (
          <Stepper item={item} key={index?.toString()} />
        ))}
      </Box>
      <Box sx={styles?.fabContainer}>
        <Box position="relative">
          <Badge
            badgeContent={badge}
            color="secondary"
            max={99}
            overlap="circular"
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={styles?.badge}
          />
          <Fab
            color="primary"
            onClick={() =>
              openDrawer(
                <FiltroModal {...formProps} onSubmit={loadLeads} />,
                'Filtros'
              )
            }
          >
            <FilterList />
          </Fab>
        </Box>

        <Fab color="primary" onClick={() => navigate(`/app/Crm/Gerar`)}>
          <Add />
        </Fab>
      </Box>
    </Container>
  );
};

export default Crm;
